import type { MouseEvent } from "react";
import { Link } from "react-router-dom";

const ORDER_NUMBER_PATTERN = /^[0-9]{7}-[0-9]{3}$/;

export function OrderLink({ orderNumber, stopPropagation = false, className = "" }: {
  orderNumber: string;
  stopPropagation?: boolean;
  className?: string;
}) {
  if (!ORDER_NUMBER_PATTERN.test(orderNumber)) return <span className={className}>{orderNumber}</span>;

  function handleClick(event: MouseEvent<HTMLAnchorElement>) {
    if (stopPropagation) event.stopPropagation();
  }

  return (
    <Link
      className={`order-link ${className}`.trim()}
      to={`/auftraege/${encodeURIComponent(orderNumber)}`}
      onClick={handleClick}
      aria-label={`Auftrag ${orderNumber} öffnen`}
    >
      {orderNumber}
    </Link>
  );
}
